import React from 'react'
import { ContainerDiv, ContainerDivProps, FjText } from 'src/components/Common'
import { LearningObjectPreviewCard } from 'src/components/Content/LearningObjectPreviewCard'
import { SubmoduleTag } from 'src/components/CourseAuthoring/SubmoduleTag'
import { Paths } from 'src/constants/navigation'
import { Course } from 'src/models/Course'
import { sharedAppStateStore } from 'src/store/AppStateStore'
import { Submodule } from 'src/models/Submodule'
import { Colors } from 'src/constants/colors'

// In the submodule list, we only display the "Not Graded" status rather than all possible statuses
const GradingStatusTag = ({ submodule }: { submodule: Submodule }) => {
  if (
    submodule.submoduleType !== 'assignment' ||
    !['submitted', 'grading_in_progress'].includes(submodule.passDetails.gradingStatus)
  ) {
    return null
  }

  return (
    <ContainerDiv padding="4px 12px" backgroundColor={Colors.concrete} borderRadius="26px">
      <FjText textAlign="left" display="block" fontSize="12px" color={Colors.shark}>
        Not Graded
      </FjText>
    </ContainerDiv>
  )
}

export const CourseSubmodulePreviewCard: React.FC<{
  course: Course
  submodule: Submodule
  checkboxDisabled?: boolean
  style?: ContainerDivProps
  updateBreadCrumb?: boolean
  beforeSubmoduleListNavigation?: () => Promise<void>
}> = ({ course, submodule, style, checkboxDisabled, updateBreadCrumb = true, beforeSubmoduleListNavigation }) => {
  const submoduleIndex = course.getAllSubmodules().findIndex((s) => submodule.id === s.id)
  const lockedFromIndex = course.getLockedFromIndex()
  const inProgress = course.progress === 1 ? false : submoduleIndex === lockedFromIndex - 1
  const locked = submoduleIndex >= lockedFromIndex && course.requireSequentialCompletion

  const handleContentClick = async () => {
    if (locked) return
    if (beforeSubmoduleListNavigation) await beforeSubmoduleListNavigation()
    sharedAppStateStore.navigate(
      Paths.getSubmodulePath(course.id, submodule.id),
      false,
      updateBreadCrumb
        ? {
            breadcrumbName: course.name,
            contentType: 'course',
            path: Paths.getCoursePath({ id: course.id, queryParams: { tab: 'details' } }),
          }
        : { retain: true }
    )
  }

  return (
    <LearningObjectPreviewCard
      objectId={submodule.id}
      inProgress={inProgress}
      isCompleted={submodule.isCompleted}
      onClickHandler={handleContentClick}
      cursorStyle={locked ? 'normal' : 'pointer'}
      checkBoxClickhandler={handleContentClick}
      isPassed={submodule.passDetails.isPassed}
      locked={locked}
      checkboxDisabled={checkboxDisabled}
      imgComponent={
        <ContainerDiv display="flex" alignItems="center" gap={8} flexWrap="wrap">
          <SubmoduleTag submodule={submodule} />
          <GradingStatusTag submodule={submodule} />
        </ContainerDiv>
      }
      title={submodule.title}
      style={style}
    />
  )
}
